import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { CancelarCompraRequest } from '../../requests/compras/cancelar-compra.request';
import { BulkCancelarCompraRequest } from '../../requests/compras/bulk-cancelar-compra.request';
import { MovimentarCompraEtapaRequest } from '../../requests/compras/movimentar-compra-etapa.request';
import { BulkCancelarCompraResponse } from '../../responses/compras/bulk-cancelar-compra.response';
import { MovimentarCompraEtapaResponse } from '../../responses/compras/movimentar-compra-etapa.response';

/**
 * Cancelamentos de compra pelo Orquestrador: repassa ao Compras (mesmos contratos) e, com notas
 * liberadas (`idsNotasDesvinculadas`), sincroniza a marca de vínculo da NF no RepoDFe. Se só a
 * marca falhar, volta `isError` com "O cancelamento foi concluído, mas…" e o resto preenchido.
 */
@Injectable({
  providedIn: 'root',
})
export class OrquestradorCompraEtapaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorCompras + 'CompraEtapa';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** Só para o destino `cancelado` (arrastar para Cancelado no quadro); o Orquestrador recusa outro destino. */
  public movimentarEtapa(idCompra: number, request: MovimentarCompraEtapaRequest): Observable<MovimentarCompraEtapaResponse> {
    return this.httpClient
      .put<MovimentarCompraEtapaResponse>(`${this.apiUrl}/${idCompra}`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public cancelarCompra(idCompra: number, request: CancelarCompraRequest): Observable<MovimentarCompraEtapaResponse> {
    return this.httpClient
      .post<MovimentarCompraEtapaResponse>(`${this.apiUrl}/${idCompra}/cancelar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public bulkCancelar(request: BulkCancelarCompraRequest): Observable<BulkCancelarCompraResponse> {
    return this.httpClient
      .post<BulkCancelarCompraResponse>(`${this.apiUrl}/bulk-cancelar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
